export const servers = [
    {
      id: "597473077663760404",
      img: "Logo1.png",
      color: "color",
      colorBlock: "NaN",
      pay: "silver",
      name: "Koi’s Playground",
      follower: "130,311",
      ownerInfo: "Server Owner",
      security: 35,
    },
    {
      id: "2",
      img: "Logo2.png",
      pay: "gold",
      color: "color",
      colorBlock: "NaN",
      name: "Capital Club",
      follower: "125,124 ",
      ownerInfo: "Bot Master",
      security: 55,
    },
    {
      id: "3",
      img: "Logo3.png",
      pay: "silver",
      color: "color",
      colorBlock: "NaN",
      name: "Unioverse",
      follower: "20,634",
      ownerInfo: "Bot Master",
      security: 85,
    },
    {
      id: "4",
      img: "Logo4.png",
      pay: "silver",
      color: "color-553E05",
      colorBlock: "color-gold_server",
      name: "Champs Only",
      follower: "20,102",
      ownerInfo: "Bot Master",
      security: 15,
    },
    {
      id: "5",
      img: "Logo5.png",
      pay: "free",
      color: "color",
      colorBlock: "NaN",
      name: "Mooncatz",
      follower: "1,872",
      ownerInfo: "Bot Master",
      security: 100,
    },
    {
      id: "6",
      img: "Logo6.png",
      pay: "silver",
      color: "color",
      colorBlock: "NaN",
      name: "Cryptelligence",
      follower: "1,500",
      ownerInfo: "Server Owner",
      security: 100,
    },
]
  
export const statusActions =[
  {
    img: "Ban.svg",
    className: "ban",
    name: "Ban",
  },
  {
    img: "Kick.svg",
    className: "kick",
    name: "Kick",
  },
  {
    img: "RevokeRoles.svg",
    className: "revoke_roles",
    name: "Revoke Roles",
  },
  {
    img: "Log.svg",
    className: "log",
    name: "Log",
  },
]

export const statusActionsAdvanced = [
        {
            img:'Ban.svg',
            className:'ban',
            name:'Ban'
        },
        {
            img:'Kick.svg',
            className:'kick',
            name:'Kick'
        },
        {
            img:'RevokeRoles.svg',
            className:'revoke_roles',
            name:'Revoke Roles'
        },
        {
            img:'Trash.svg',
            className:'warn',
            name:'Warn'
        },
        {
            img:'Log.svg',
            className:'log',
            name:'Log'
        },

    ]